import React, { useEffect, useRef, useState } from "react";

/**
 * Reveal, fades content up when it enters the viewport.
 * Uses IntersectionObserver; respects prefers-reduced-motion via CSS in index.css.
 */
export default function Reveal({
  children,
  as: Tag = "div",
  delay = 0,
  y = 24,
  threshold = 0.15,
  className = "",
  once = true,
  ...rest
}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          if (once) io.disconnect();
        } else if (!once) {
          setVisible(false);
        }
      },
      { threshold, rootMargin: "0px 0px -60px 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [threshold, once]);

  return (
    <Tag
      ref={ref}
      className={className}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : `translateY(${y}px)`,
        transition: `opacity 780ms cubic-bezier(0.22, 1, 0.36, 1) ${delay}ms, transform 780ms cubic-bezier(0.22, 1, 0.36, 1) ${delay}ms`,
        willChange: "opacity, transform",
      }}
      {...rest}
    >
      {children}
    </Tag>
  );
}
